module.exports = __webpack_public_path__ + "img/product2_007FFF_occupation.4e03b1ec.png";